import React from 'react'
import { Link } from 'react-router-dom'

import { Space, Result } from 'antd-mobile'
import { HomeOutlined } from '@ant-design/icons'

import { useAuth } from '../../contexts/AuthContextProvider'

const ForbiddenPage = () => {
  const { userId } = useAuth()
  return (
    <Space justify='center' block style={{ marginTop: '25%' }}>
      <Link to={(userId) ? '/admin' : '/login'} style={{ textDecoration: 'none', color: 'black' }}>
        <Result
          icon={<HomeOutlined style={{ fontSize: 48, color: '#ff8f1f' }} />}
          title='Forbidden!'
          description='Sorry, you not allow to access this page.'
        />
      </Link>
    </Space>
  )
}

export default ForbiddenPage
